var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClients(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H175L200 25V200H0V0Z",
    fill: "#00CC99"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7502 73.492L62.2127 75.028H45.0002V82.521H65.2877L71.2502 76.5641V63.7886H41.2502V71.2815H63.7502V73.492Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2125 56.2954L76.0875 72.3679L81.4125 77.6879L95.2875 63.7884H97.5V69.7453L73.4625 93.7603H37.5V52.549H15V105H37.5V101.253H76.5375L105 72.8174V56.2954H92.2125ZM30 97.5068H22.5V60.0419H30V97.5068Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7502 48.8027H78.7502V56.2957H86.2502V41.3097H73.5752C75.8857 39.3088 77.529 36.6502 78.2848 33.6901C79.0405 30.7299 78.8728 27.6098 77.8039 24.7476C76.7351 21.8854 74.8162 19.4179 72.3045 17.6758C69.7927 15.9336 66.8079 15 63.7502 15C60.6924 15 57.7077 15.9336 55.1959 17.6758C52.6841 19.4179 50.7653 21.8854 49.6964 24.7476C48.6276 27.6098 48.4598 30.7299 49.2156 33.6901C49.9714 36.6502 51.6147 39.3088 53.9252 41.3097H41.2502V56.2957H48.7502V48.8027ZM63.7502 22.5773C65.2335 22.5773 66.6836 23.0168 67.917 23.8401C69.1503 24.6635 70.1116 25.8337 70.6793 27.2029C71.2469 28.572 71.3955 30.0786 71.1061 31.5321C70.8167 32.9856 70.1024 34.3207 69.0535 35.3686C68.0046 36.4165 66.6682 37.1302 65.2134 37.4193C63.7585 37.7084 62.2505 37.56 60.8801 36.9929C59.5096 36.4258 58.3383 35.4654 57.5142 34.2332C56.6901 33.001 56.2502 31.5523 56.2502 30.0703C56.2502 28.083 57.0404 26.1772 58.4469 24.772C59.8534 23.3668 61.7611 22.5773 63.7502 22.5773Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClients);
export default __webpack_public_path__ + "static/media/clients.51817dc5ebab27069e1131b57c51e2e9.svg";
export { ForwardRef as ReactComponent };